import { COLORS } from '@app/constants';
import React, { useContext, useEffect, useState } from 'react';
import { View } from '@/styles/reactnative';
import TpslCheckBox from './TpslCheckBox';
import TpslDetail from './TpslDetail';
import useTradeStore from '../../../../../../hooks/trade/tradeStore';
import { ThemeContext } from '@/theme/ThemeProvider.tsx';
import { Flex, Input } from 'antd';
import { MText } from '@/styles/mobilePageStyles.tsx';
import { isMobile } from 'react-device-detect';
import { useIsMobile, useIsTablet } from '@utils/CalVW.tsx';
import { useTranslation } from 'react-i18next';
import { t } from 'i18next';
import styled from 'styled-components';
import { CButton } from '@/app/components/Common';
import BigNumber from 'bignumber.js';

const DerivativesTpSl = () => {
  const { data: tradeStore, mutate } = useTradeStore();
  const { t } = useTranslation();

  const [buyTpsl, setBuyTpsl] = useState<boolean>(false);
  const [display, setDisplay] = useState<boolean>(false);
  const [tpslPercentage, setTpslPercentage] = useState('');
  const [stopLossPercentage, setStopLossPercentage] = useState('');
  const [tpslValue, setTpslValue] = useState('');
  const [stopLossValue, setStopLossValue] = useState('');
  const [tradeTpslType, setTradeTpslType] = useState('USDT');
  const [tradeLossType, setTradeLossType] = useState('USDT');
  const isMobile = useIsMobile();

  useEffect(()=>{
    setBuyTpsl(false);
  },[tradeStore?.ep_id])

  useEffect(() => {
    mutate({
      ...tradeStore,
      tpsl: buyTpsl,
      tp: tpslValue,
      sl: stopLossValue,
      tptype: tradeTpslType,
      sltype: tradeLossType,
    });
  }, [buyTpsl, tpslValue, stopLossValue, tradeTpslType, tradeLossType]);

  useEffect(() => {
    setDisplay(buyTpsl);
  }, [buyTpsl]);

  return (
    <View
      style={{
        width: '100%',
        marginBottom: 15,
      }}
    >
      <View
        style={{
          width: '100%',
          flexDirection: 'row',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
        }}
      >
        <TpslCheckBox
          title={t('TP/SL')}
          checked={buyTpsl}
          setChecked={setBuyTpsl}
          color={COLORS.primary}
        />
      </View>
      {display ? (
        // <TpslDetail
        //   tpslPercentage={tpslPercentage}
        //   setTpslPercentage={setTpslPercentage}
        //   tpslValue={tpslValue}
        //   setTpslValue={setTpslValue}
        //   stopLossValue={stopLossValue}
        //   setStopLossValue={setStopLossValue}
        //   stopLossPercentage={stopLossPercentage}
        //   setStopLossPercentage={setStopLossPercentage}
        //   tradeTpslType={tradeTpslType}
        //   setTradeTpslType={setTradeTpslType}
        //   tradeLossType={tradeLossType}
        //   setTradeLossType={setTradeLossType}
        // />

        <div
          style={{
            padding: isMobile ? '10px 0 0 0' : '10px 5px',
            display: 'flex',
            flexDirection: 'column',
            gap: isMobile ? 6 : 30,
            width: '100%',
          }}
        >
          <TPSLCustomRow
            // key={"tp"}
            type={'tp'}
            isSmall={true}
            price={0}
            amount={0}
            positionType={'entire'}
            // leverage={leverage}
            // margin={margin}
            // long_short={long_short}
            // defaultValue={tpsl?.tp}
            // value={tp}
            // setValue={setTp}
            // isMobile={isMobile}
            // positionType={position}
          />

          <TPSLCustomRow
            // key={"sl"}
            type={'sl'}
            isSmall={true}
            price={0}
            amount={0}
            positionType={'entire'}
            // leverage={leverage}
            // margin={margin}
            // long_short={long_short}
            // defaultValue={tpsl?.sl}
            // value={sl}
            // setValue={setSl}
            // isMobile={isMobile}
            // positionType={position}
          />
        </div>
      ) : null}
    </View>
  );
};

export default DerivativesTpSl;

const TPSLCustomRow = (props: {
  type: 'tp' | 'sl';
  price?;
  amount?;
  leverage?;
  margin?;
  long_short?;
  defaultValue?;
  value?;
  setValue?;
  isMobile?: boolean;
  isSmall?: boolean;
  positionType?: 'entire' | 'partial';
}) => {
  const {
    theme: { COLORS },
    isDarkMode,
  } = useContext(ThemeContext);

  const { textw, gray, bgColor, mobileTradeBorder, textsilver } = COLORS;

  const { data: tradeStore, mutate: setTradeStore } = useTradeStore();

  const isMobile = useIsMobile();
  const isTablet = useIsTablet();

  const [targetPrice, setTargetPrice] = useState(isMobile ? '0' : '');

  const handleChange = (e) => {
    const inputValue = e.target.value;

    // 빈 값이면 그대로
    if (inputValue === '') {
      setTargetPrice('');
      if (props.type === 'tp') {
        setTradeStore({ ...tradeStore, tp: '' });
      } else {
        setTradeStore({ ...tradeStore, sl: '' });
      }
      return;
    }

    const dp = tradeStore?.dp || 3;

    // 소수점이 있는지 체크
    const decimalIndex = inputValue.indexOf('.');

    if (decimalIndex !== -1) {
      // 소수점 이하 자리수 계산
      const decimalPlaces = inputValue.length - decimalIndex - 1;

      // dp를 초과하면 입력을 막음
      if (decimalPlaces > dp) {
        return;
      }
    }

    // dp 이하면 입력 허용
    setTargetPrice(inputValue);

    if (props.type === 'tp') {
      setTradeStore({
        ...tradeStore,
        tp: inputValue,
      });
    } else {
      setTradeStore({
        ...tradeStore,
        sl: inputValue,
      });
    }
  };

  // blur 시 후행 0 제거
  const handleBlur = () => {
    if (!targetPrice || targetPrice === '') return;

    let finalValue = targetPrice.toString();
    finalValue = finalValue.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.0+$/, '');

    setTargetPrice(finalValue);
    if (props.type === 'tp') {
      setTradeStore({ ...tradeStore, tp: finalValue });
    } else {
      setTradeStore({ ...tradeStore, sl: finalValue });
    }
  };

  const handleChangeButton = (type: 'plus' | 'minus') => {
    if (type === 'plus') {
      const newTargetPrice = new BigNumber(targetPrice).plus(1).toString();
      setTargetPrice(newTargetPrice);
      setTradeStore({
        ...tradeStore,
        tp: newTargetPrice,
      });
    } else {
      const newTargetPrice = new BigNumber(targetPrice).minus(1).toString();
      setTargetPrice(newTargetPrice);
      setTradeStore({
        ...tradeStore,
        sl: newTargetPrice,
      });
    }
  };

  const label =
    props.type === 'tp' ? t('TakeProfitSetting') : t('StopLossSetting');
  const smalllabel = props.type === 'tp' ? t('TakeProfit') : t('StopLoss');

  return isMobile ? (
    <MContainer
      isDarkMode={isDarkMode}
      style={{
        border: `1px solid ${mobileTradeBorder}`,
        color: textw,
      }}
    >
      <CButton
        style={{
          background: 'transparent',
          border: 'none',
          fontSize: '16px',
          cursor: 'pointer',
        }}
        title={'-'}
        onClick={() => handleChangeButton('minus')}
      />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 4,
          alignItems: 'center',
        }}
      >
        <CButton
          title={`${smalllabel} (USDT)`}
          style={{
            fontSize: 12,
            color: textsilver,
          }}
        />
        <div>
          <Input
            type="number"
            value={targetPrice}
            onChange={handleChange}
            onBlur={handleBlur}
            step={Math.pow(10, -(tradeStore?.dp || 3)).toString()}
            style={{
              width: 'fit-content',
              border: 'none',
              textAlign: 'center',
              padding: 0,
              fontFamily: 'Binance PLEX',
              background: 'transparent',
            }}
          />
        </div>
      </div>
      <CButton
        style={{
          background: 'transparent',
          border: 'none',
          fontSize: '16px',
          cursor: 'pointer',
        }}
        title={'+'}
        onClick={() => handleChangeButton('plus')}
      />
    </MContainer>
  ) : (
    <Flex
      vertical
      align={'start'}
      gap={props.isMobile ? 'middle' : 'small'}
      style={{ width: '100%' }}
    >
      <MText style={{ color: textw }}>
        {props.isSmall ? smalllabel : label}
      </MText>
      <Input
        type="number"
        value={targetPrice}
        onChange={handleChange}
        onBlur={handleBlur}
        step={Math.pow(10, -(tradeStore?.dp || 3)).toString()}
        size={props.isMobile ? 'middle' : 'small'}
        suffix={<div style={{ fontSize: 12, fontWeight: 600 }}>USDT</div>}
        style={{
          width: isTablet ? '100%' : props.isSmall ? '12.5vw' : '50%',
          color: textw,
          backgroundColor: bgColor,
          padding: '3px 10px',
          borderRadius: 6,
        }}
      />
    </Flex>
  );
};

const MContainer = styled.div<{ isDarkMode: boolean }>`
  border-radius: 6px;
  background: gray;
  color: textw;
  margintop: 5;
  padding: 4px 12px;
  width: 100%;
  background-color: ${({ isDarkMode }) => (isDarkMode ? '#0C110E' : '#F8F4F0')};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
